import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { getEnrichedDailyTradingTip } from '../../engines/tradingTipEngine';
import ContentShareMenu from '../ContentShareMenu/ContentShareMenu';

const SENTIMENT_STYLES = {
    bullish: { label: 'Bullish bias', className: 'trading-tip-sentiment--bullish' },
    bearish: { label: 'Caution', className: 'trading-tip-sentiment--bearish' },
    neutral: { label: 'Neutral', className: 'trading-tip-sentiment--neutral' },
};

function TradingTipCard() {
    const [tip, setTip] = useState(null);

    useEffect(() => {
        let active = true;

        getEnrichedDailyTradingTip()
            .then((result) => {
                if (active) setTip(result);
            })
            .catch(() => {
                if (active) {
                    import('../../engines/tradingTipEngine').then(({ getDailyTradingTip }) => {
                        setTip(getDailyTradingTip());
                    });
                }
            });

        return () => {
            active = false;
        };
    }, []);

    if (!tip) {
        return (
            <aside className="trading-tip-card trading-tip-card--loading" aria-label="Loading daily trading tip">
                <div className="trading-tip-skeleton" />
            </aside>
        );
    }

    const sentiment = SENTIMENT_STYLES[tip.sentiment] || SENTIMENT_STYLES.neutral;

    const shareText = tip.market
        ? `${tip.analysis} (${tip.market.symbol} ${tip.market.changePercent >= 0 ? '+' : ''}${tip.market.changePercent.toFixed(2)}% 24h)`
        : tip.analysis;

    return (
        <aside id="daily-trading-tip" className="trading-tip-card" aria-label="Daily trading analysis tip">
            <div className="trading-tip-header">
                <div className="trading-tip-header-left">
                    <Icon icon="mdi:chart-timeline-variant" className="trading-tip-icon" aria-hidden="true" />
                    <div>
                        <p className="trading-tip-eyebrow">Daily trading tip</p>
                        <p className="trading-tip-date">{tip.dayLabel}</p>
                    </div>
                </div>
                <div className="trading-tip-header-actions">
                    <span className={`trading-tip-sentiment ${sentiment.className}`}>
                        {sentiment.label}
                    </span>
                    <ContentShareMenu
                        title={`NeuraTrader daily tip: ${tip.title}`}
                        text={shareText}
                        shareHash="daily-trading-tip"
                        label="Share"
                    />
                </div>
            </div>

            <p className="trading-tip-category">{tip.category}</p>
            <h3 className="trading-tip-title">{tip.title}</h3>
            <p className="trading-tip-analysis">{tip.analysis}</p>

            {tip.market && (
                <div className="trading-tip-market">
                    <span className="trading-tip-market-symbol">{tip.market.symbol}</span>
                    <span className="trading-tip-market-price">
                        ${tip.market.price.toLocaleString(undefined, { maximumFractionDigits: 2 })}
                    </span>
                    <span className={`trading-tip-market-change ${tip.market.changePercent >= 0 ? 'is-up' : 'is-down'}`}>
                        {tip.market.changePercent >= 0 ? '+' : ''}
                        {tip.market.changePercent.toFixed(2)}% 24h
                    </span>
                </div>
            )}

            <Link to="/learn" className="trading-tip-link">
                Apply this in bot setup guides →
            </Link>
        </aside>
    );
}

export default TradingTipCard;